export namespace FeatureFlags {
  export const EXTEND_DEACTIVATION = 'extendDeactivation';
  export const STUDENT_MANAGEMENT = 'adminStudentManagement';
  export const STUDENT_DATA_EXPORT = 'studentDataExport';
  export const MULTIPLE_IEPS = 'multipleIEPs';
  export const SUBSCRIPTION_MANAGEMENT = 'subscriptionManagement';
  export const SHOW_PLATFORM_SWITCHER = 'showPlatformSwitcher';
  export const USE_MATERIAL_CASELOAD_LIST = 'useMaterialCaseloadList';
  export const KANGA_LANDING_PAGE = 'kangaLandingPage';
  export const SHOW_SECURITY_SETTINGS = 'showSecuritySettings';
  export const SHOW_EVENT_SERVICE_TYPE = 'showEventServiceType';
  export const REDIRECT_KANGA_ADMINS_TO_PRESENCE_ADMIN_DASHBOARD =
    'redirectKangaAdminsToPresenceAdminDashboard';
  export const ADD_STUDENT_FROM_EVENT_FLOW = 'addStudentFromEventFlow';
  export const AUTO_FILL_LOCATION_FROM_CASELOAD =
    'autoFillLocationFromCaseload';
  export const HIDE_EXTERNAL_TOOLS = 'hideExternalTools';
  export const POLISH_SESSION_NOTES = 'polishSessionNotes';
}

export type FeatureFlagName = (typeof FeatureFlags)[keyof typeof FeatureFlags];
